import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';
import { AdminService, ToolbarStateAdmin, ToolbarTypeAdmin } from './admin.service';

@Component({
    selector: 'app-admin2',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false
})
export class AdminComponent extends AdminActionsDirective implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private router: Router,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.activatedRoute.params.subscribe(async params => {
                const type = this.router.url.split('/')[2];
                const action = this.router.url.split('/')[3];

                if ((type as ToolbarTypeAdmin) === ToolbarTypeAdmin.Faq && !this.isFaqModuleActive) {
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: ToolbarTypeAdmin.Users
                    });
                    return;
                }

                if ((type as ToolbarTypeAdmin) === ToolbarTypeAdmin.Glossary && !this.isGlossaryModuleActive) {
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: ToolbarTypeAdmin.Users
                    });
                    return;
                }

                if ((type as ToolbarTypeAdmin) === ToolbarTypeAdmin.Hyperlinks && !this.isHyperlinksModuleActive) {
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: ToolbarTypeAdmin.Users
                    });
                    return;
                }

                if (
                    (type as ToolbarTypeAdmin) === ToolbarTypeAdmin.Responsibilities &&
                    !this.isOrganisationModuleActive
                ) {
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: ToolbarTypeAdmin.Users
                    });
                    return;
                }

                if ((type as ToolbarTypeAdmin) === ToolbarTypeAdmin.Reports && !this.isReportModuleActive) {
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: ToolbarTypeAdmin.Users
                    });
                    return;
                }

                if (
                    (type as ToolbarTypeAdmin) === ToolbarTypeAdmin.ReportTemplates &&
                    !this.isReportTemplateModuleActive
                ) {
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: ToolbarTypeAdmin.Users
                    });
                    return;
                }

                if (action === 'create') {
                    if (params.id) {
                        this.selectedItem = this.selectedItem?.id === params.id ? this.selectedItem : { id: params.id };
                    }
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Create,
                        type: type as ToolbarTypeAdmin,
                        selectedItem: this.selectedItem
                    });
                } else if (params.id) {
                    this.selectedItem = this.selectedItem?.id === params.id ? this.selectedItem : { id: params.id };
                    if (action === 'edit') {
                        this.adminService.toolbarChanged.next({
                            state: ToolbarStateAdmin.Edit,
                            selectedItem: this.selectedItem,
                            type: type as ToolbarTypeAdmin
                        });
                    } else {
                        this.adminService.toolbarChanged.next({
                            state: ToolbarStateAdmin.Info,
                            selectedItem: this.selectedItem,
                            type: type as ToolbarTypeAdmin
                        });
                    }
                } else {
                    // this.goToMainView();
                    this.adminService.toolbarChanged.next({
                        state: ToolbarStateAdmin.Standard,
                        type: (type as ToolbarTypeAdmin) ?? ToolbarTypeAdmin.Users
                    });
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(e => e.unsubscribe());
    }
}
